import { Component, Inject, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Router } from "@angular/router";
import { BaseService } from 'src/app/shared/services';
import { UserService } from 'src/app/shared/services/user.service';
import {
  NgForm,
} from "@angular/forms";
import { UtilsService } from 'src/app/shared/services/utils.service';
import { DownloadService } from 'src/app/shared/services/download.service';
import { QuotesService } from '../../shared/services/quotes.service';
import { CountryGuideService } from 'src/app/shared/services/countryGuide.service';
import { MapquoteService } from 'src/app/shared/services/mapquote.service';
import { Subject } from "rxjs";
import { DomSanitizer } from '@angular/platform-browser';
import { IWGSharedService } from 'src/app/shared/services/shared.service';

@Component({
  selector: 'app-quotes-dialog',
  templateUrl: './quotes-dialog.component.html',
  styleUrls: ['./quotes-dialog.component.scss']
})
export class QuotesDialogComponent implements OnInit {
  resetFormSubject: Subject<any> = new Subject<any>();
  index:any;
  @ViewChild("quoteStep1") quoteStep1:NgForm;
  @ViewChild("quoteStep2") quoteStep2:NgForm;
  @ViewChild("quoteStep3") quoteStep3:NgForm;
  @ViewChild("quoteStep4") quoteStep4:NgForm;
  countryGuide:any;
isLoading = false;
maxSteps = 5;
selectedStepIndex = 0;
existingQuoteId = null;
pageLoaded= false;
quoteMapCode:any;
ngAfterViewInit(){
    this.pageLoaded = true;
}
step1 = {
  is_bonus_authorized:false,
  service_type_id:null,
  include_EOR: null,
  include_Compliance:null,
  include_AOR: null,
  title:null,
  selectedEndClient: null,
  selectedTeam:null,
  expat_nationality:null,
  selectedState:null,
  city:null,
  selectedCountry:null,
  selectedServiceName:null
};
// {ID: "77719610-1870-4b20-be3b-d076b6cc5b85",
//   Name: "Client_Intl_Team1"}
// {Abbreviation: "IN-NL",
//   CountryAbbreviation: "IN",
//   CountryID: "0f2f8eeb-509c-456c-a4d5-87f07de40ffd",
//   ID: "a1214f95-6097-47ea-a0c7-74978c381765",
//   ImageURL: "https://images.iworkglobal.com/country-us-Nagaland.jpg",
//   Name: "Nagaland"}
step2 = {
  number_of_workers:null,
  is_entity_in_country:null,
  is_expat:null,
  expat_nationality:null,
  is_worker_in_country:null,
  is_expat_visa_required:null
};
step3 = {
  job_title:null,
  is_travel_required:null,
  job_description:null,
  job_description_file:null,
  job_description_file_id:null
};
step4 = {
  start_date:null,
  weekly_hours:null,
  is_project_length_indefinite:null,
  project_length_years:null,
  project_length_months:null,
  project_length_weeks:null,
  pay_rate:null,
  selectedCurrency:null,
  selectedPayRateType:null,
  is_commission_authorized:null,
  is_bonus_authorized:null,
  other_compensation:null,
  client_notes:null
};
Hposition:MatSnackBarHorizontalPosition = "right";
VPosition:MatSnackBarVerticalPosition = "top";

allowEndClients:any;
allowTeams:any;
showRegions = true;
TransferEORAssingmnetId = null;
isFileUploadInProgress:boolean = false;
JobDescriptionFile:any;
name:any;


  constructor(private baseService: BaseService,
    public router: Router,
    private dialogRef: MatDialogRef<QuotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private toast:MatSnackBar,
    private user:UserService,
    private utils:UtilsService,private downloadService: DownloadService,    private quoteService: QuotesService,
    public countryGuideService: CountryGuideService,
    private sanitizer: DomSanitizer,
    private sharedService:IWGSharedService
  //  public map: MapquoteService
    ) { 
      this.name = data;
    }

  ngOnInit(): void {
    this.isFileUploadInProgress = false;
    this.allowEndClients = this.user.getAllowEndClients();
    this.allowTeams= this.user.getAllowTeams();
    this.step1.include_EOR= !this.user.getEORDisabled();
    this.step1.include_Compliance= !this.user.getComplianceDisabled();
    this.step1.include_AOR= !this.user.getAORDisabled();
    this.getCountryRegionCode(this.step1.selectedCountry?.Abbreviation, this.step1.selectedState)
      // this.step1.service_type_id=1;
      if(this.name.isTransferToEOR == true && this.name.existingAssignment){
        this.populateEvaluationToQuotePopUp(this.name.existingAssignment)
      } else if(this.name.existingQuote){
        this.populateForm(this.name.existingQuote)
      }
    }
    prevStep() {
      this.resetFileErrorMessages();
      this.selectedStepIndex -= 1;
      if (this.step1.service_type_id == 3 || this.step1.service_type_id == 2) {
          this.selectedStepIndex = 0;
      }
  }
  
  cancel() {
    this.dialogRef.close();
    }
  
  resetFileErrorMessages(){
    
  }
  
  getCountryRegionCode(countryCode, regionCode,hasRegion=false){   

    // this.step1.selectedCountry=countryCode;
    this.step1.selectedState=this.step1.selectedState==null?regionCode:this.step1.selectedState; 
    let code;

    if (regionCode && regionCode.Abbreviation?.length > 2) {
        code = regionCode.Abbreviation;
    } else if (regionCode && regionCode.Abbreviation?.length == 2) {
        code = countryCode.Abbreviation + '-' + regionCode.Abbreviation;
    } else if (hasRegion) {
      code =countryCode.Abbreviation ;
    }
    else {
        code = countryCode;
    }   
    this.quoteMapCode = code;
    this.resetFormSubject.next(code);
 }
OnChangeDuration(hint:any){
  if (hint == 'years' || hint == 'months' || hint == 'weeks') {
    this.step4.is_project_length_indefinite = false;
    if (this.step4.project_length_months == null || this.step4.project_length_months == '') {
        this.step4.project_length_months = 0;
    }
    if (this.step4.project_length_weeks == null || this.step4.project_length_weeks == '') {
        this.step4.project_length_weeks = 0;
    }
    if (this.step4.project_length_years == null || this.step4.project_length_years == '') {
        this.step4.project_length_years = 0;
    }
}
else if (hint == 'indefinite') {
    this.step4.project_length_years = '';
    this.step4.project_length_months = '';
    this.step4.project_length_weeks = '';
}
}
nextStep() {
  let canProceed = false;
  let stepIndex = this.selectedStepIndex + 1;  
  switch (stepIndex) {
      case 1:
          // this.quoteStep1.$setSubmitted();
          canProceed = this.quoteStep1.valid;
          // 
          if (this.step1.selectedState == null && this.step1.selectedCountry.HasRegions == true && this.showRegions == true) {
              alert('Please select a state or region');
              canProceed = false;
          }

          //set the region to null if the country has no regions
          if (this.step1.selectedCountry.HasRegions == false) {
              this.step1.selectedState = null;
          }

          if (canProceed) {
              this.loadCountryGuide();
          }
          break;
      case 2:
          // this.quoteStep2.$setSubmitted();
          canProceed = this.quoteStep2.valid;
          break;
      case 3:
          // this.quoteStep3.$setSubmitted();
          canProceed = this.quoteStep3.valid;         
          if
              (
              this.step1.service_type_id == 1 && //only for EOR
              (this.step3.job_description_file == '' || this.step3.job_description_file == null) &&
              (this.step3.job_description == '' || this.step3.job_description == null)
          ) {
              alert('Please enter the job description or upload a file');
              canProceed = false;
          }
          break;
      case 4:
          // this.quoteStep4.$setSubmitted();
          canProceed = this.quoteStep4.valid;
          if (this.step4.is_project_length_indefinite == false && (
              (this.step4.project_length_months == '' || this.step4.project_length_months == '0' || this.step4.project_length_months == 0) &&
              (this.step4.project_length_weeks == '' || this.step4.project_length_weeks == '0' || this.step4.project_length_weeks == 0) &&
              (this.step4.project_length_years == '' || this.step4.project_length_years == '0' || this.step4.project_length_years == 0)
          )) {
              canProceed = false;
              alert('Please Ensure the Length of Project is Valid');
          }
          break;
  }

  if (canProceed) {
      this.index = (this.selectedStepIndex == this.maxSteps) ? 0 : this.selectedStepIndex + 1;

      //for Compliance, skip to the end review after the first step
      if (this.step1.service_type_id == 3 || this.step1.service_type_id == 2) {
          this.index = 4;
      }

      this.saveDraft().then(() => {
          this.selectedStepIndex = this.index;
      })
  } else {
      // TODO: Focus on invalid element
  }
  this.resetFileErrorMessages();
}
saveAsDraft() {
  this.saveDraft().then((response) => {
      if (response.data.ErrorCode == 200) {
          this.dialogRef.close();
          this.showConfirmationToast('Draft has been saved.');
          this.sharedService.isStateChange.next(true);
          // if (this.isEditFromDetails == true) {
          //     $state.reload();
          // }
      } else {
        this.dialogRef.close();
          this.showConfirmationToast('Error saving draft.');
          // console.error(error);
      }
  });
}


goNext(tabId)
{
  this.selectedStepIndex = tabId;
}

saveDraft() {
  // Draft status
  const statusId = 1;
  return this.save(statusId);
}
save(statusId) {
  this.isLoading = true;

  let props = {
      new_status_id: statusId
  };
  
  if (this.quoteStep1.valid) {
    Object.assign(props, {
          service_type_id: this.step1.service_type_id,
          title: this.utils.htmlDecode(this.step1.title),
          city: this.step1.city,
          end_client_id: (this.step1.selectedEndClient != null) ? this.step1.selectedEndClient.ID : 0,
          country_id: this.step1.selectedCountry.ID,
          //team_id: this.step1.selectedTeam.ID,
          team_id: (this.step1.selectedTeam != null) ? this.step1.selectedTeam.ID : 0          
      });
      
      if(this.TransferEORAssingmnetId > 0){
        Object.assign(props, {
          transfer_eor_assignment_id : this.TransferEORAssingmnetId
        });
      }

      this.step1.selectedServiceName = this.utils.getServiceName(this.step1.service_type_id);

      if (this.step1.selectedState) {
        Object.assign(props, {
              state_id: this.step1.selectedState.ID,
          });
      }
  }

  if (this.quoteStep2.valid) {
    Object.assign(props, {
          is_entity_in_country: this.step2.is_entity_in_country,
          number_of_workers: this.step2.number_of_workers,
          is_expat: this.step2.is_expat,
          is_expat_visa_required: this.step2.is_expat_visa_required,
          is_worker_in_country: this.step2.is_worker_in_country,
          expat_nationality_id: (this.step2.expat_nationality != null) ? this.step2.expat_nationality.ID : null,
      });
  }


  if (this.quoteStep3.valid) {

      //reload the file name and id                
      // this.repopulateFileUploads();

      Object.assign(props, {
          is_travel_required: this.step3.is_travel_required,
          job_title: this.utils.htmlDecode(this.step3.job_title),
          job_description: this.step3.job_description,
          job_description_file: this.step3.job_description_file,
          job_description_file_id: this.step3.job_description_file_id,
          /*type_of_work: this.step3.type_of_work,*/
      });

  }

  if (this.quoteStep4.valid) {
    Object.assign(props, {
          weekly_hours: this.step4.weekly_hours,
          pay_rate: this.step4.pay_rate,
          project_length_years: this.step4.project_length_years,
          project_length_months: this.step4.project_length_months,
          project_length_weeks: this.step4.project_length_weeks,
          is_project_length_indefinite: this.step4.is_project_length_indefinite,
          start_date: this.step4.start_date,
          currency_id: this.step4.selectedCurrency?this.step4.selectedCurrency.ID:null,
          pay_rate_type_id: this.step4.selectedPayRateType?this.step4.selectedPayRateType.ID:null,

          is_commission_authorized: this.step4.is_commission_authorized,
          is_bonus_authorized: this.step4.is_bonus_authorized,
          other_compensation: this.step4.other_compensation,

          client_notes: this.step4.client_notes

      })
  }

  if (this.existingQuoteId) {
    return this.quoteService
    .update(this.existingQuoteId, props).toPromise()
    .then(data=>{this.onSaveSuccess(data);
      this.sharedService.isStateChange.next(true);
      return data;})
    .catch(err=>this.onSaveError(err)); 
      // let prom = QuotesFactory.update({ id: this.existingQuoteId }, props).$promise;
      // prom.then(onSaveSuccess, onSaveError);
      // return prom;
  } else {
    return this.quoteService
    .quotes(props).toPromise()
    .then(data=>{this.onSaveSuccess(data);
      this.sharedService.isStateChange.next(true);return data;})
    .catch(err=>this.onSaveError(err)); 

      // let quote = new QuotesFactory(props);
      // return quote.$save().then(onSaveSuccess, onSaveError);
  }
}
onSaveSuccess(response) {
  this.isLoading = false;
  if (response.data.ErrorCode != undefined && response.data.ErrorCode == 406) {
      this.index = 0;
      alert(response.data.Message.Details);
  } else {
      if (response.apiCallStatus==0) {
           console.error(response);
      }
      if (response != null && response.data.Data != null && response.data.Data != undefined) {
      this.existingQuoteId = response.data.Data.ID;
      }
      
      // if (response.IsSuccessful) {
      //   this.dialogRef.close();
      //     this.showConfirmationToast('Thank you! We will respond to your request within 1 business day.');
      // } else {
      //   this.showConfirmationToast('Error submitting form.');
       
      // }
      // Let everyone know that there has been a change
      // $rootScope.$emit('iwg.quote.change');
  }
}

onSaveError(error) {
  this.isLoading = false;
  console.error(error);
}
canProceed(){
  let step = this.selectedStepIndex + 1;
  let valid = false;
  if (this['quoteStep' + step]) {
      valid = this['quoteStep' + step].valid;

      //require a region to be selected for countries that support regions.
      if (step == 1) {
        
          if (this.step1.selectedCountry != null) {
              if ((this.step1.selectedState == null||this.step1.selectedState == -1) && this.step1.selectedCountry.HasRegions && this.showRegions == true) {
                  valid = false;
              }
          }
          if (this.step1.selectedCountry == null || this.step1.selectedCountry<=0) {           
            valid = false;
          }
      }

      if (step == 2) {
          if (this.step2.is_expat == true && this.step2.expat_nationality == null && this.step1.service_type_id == 1) {
              valid = false;
          }
      }

      //Do not show the Save & Continue button if there's not one of a job description file or text.
      if (step == 3) {            
          if
              (
              this.step1.service_type_id == 1 && //only for EOR
              (this.step3.job_description_file == '' || this.step3.job_description_file == null) &&
              (this.step3.job_description == '' || this.step3.job_description == null)
          ) {
              valid = false;
          }
      }
  }

  return valid;
};


OnChangeServiceType(){
  this.SetServiceLabels();
}
SetServiceLabels(){
  if (this.step1.service_type_id == 3 || this.step1.service_type_id == 2) {
      this.maxSteps = 2;
      this.allowEndClients = false;
      this.showRegions = false;
  }
  else {
      this.maxSteps = 5;
  }
}
downloadJobDescriptionFile(){
  this.isLoading = true;
  this.downloadService.saveAs('/Api/File/' + this.step3.job_description_file_id).then (res=> {
    this.isLoading = false;
  });
}
populateForm(existingQuote) {
  //eee: Enable services based on user access rights.

  Object.assign(this.step1, {
      include_EOR: !this.user.getEORDisabled(),
      include_Compliance: !this.user.getComplianceDisabled(),
      include_AOR: !this.user.getAORDisabled()
  });

  if (existingQuote) {
      //let quoteRequest = existingQuote.QuoteRequest;
      
      this.TransferEORAssingmnetId = existingQuote.TransferEORAssingmnetId;

      this.existingQuoteId = existingQuote.QuoteClient_ID       //existingQuote.ID;

      Object.assign(this.step1, {
          service_type_id: existingQuote.QuoteRequest_Service_ServiceTypeEnumID,      //quoteRequest.Service.ServiceTypeEnumID,
          title: this.utils.htmlDecode(existingQuote.QuoteRequest_Title),        //quoteRequest.Title,
          city: existingQuote.QuoteRequest_City,      //quoteRequest.City,
          country_id: existingQuote.QuoteRequest_Country_ID,      //quoteRequest.Country.ID,
          team_id: existingQuote.QuoteRequest_Team_ID,        //existingQuote.Team.ID,
          end_client_id: (existingQuote.QuoteRequest_EndClient_ID != null) ? existingQuote.QuoteRequest_EndClient_ID : 0      //(quoteRequest.EndClient != null) ? quoteRequest.EndClient.ID:0
      });

      // this.step1.selectedCountry = quoteRequest.Country;
      this.step1.selectedCountry = {
          ID: existingQuote.QuoteRequest_Country_ID,
          Abbreviation: existingQuote.QuoteRequest_Country_Abbreviation,
          HasRegions: existingQuote.QuoteRequest_Country_HasRegions,
          Name: existingQuote.QuoteRequest_Country_Name
      };

      this.step1.selectedTeam = existingQuote.Team;
      this.step1.selectedTeam = {
          ID: existingQuote.QuoteRequest_Team_ID,
          Name: existingQuote.QuoteRequest_Team_Name
      };
      //this.step1.selectedState = quoteRequest.Region;
      if(existingQuote.QuoteRequest_Region_ID !=null){
      this.step1.selectedState = {
          ID: existingQuote.QuoteRequest_Region_ID,
          Name: existingQuote.QuoteRequest_Region_Name,
          Abbreviation: existingQuote.QuoteRequest_Region_Abbreviation
      };
    }

      //this.step1.selectedEndClient = quoteRequest.EndClient;
      this.step1.selectedEndClient = {
          ID: existingQuote.QuoteRequest_EndClient_ID,
          Name: existingQuote.QuoteRequest_EndClient_Name,
          ClientID: existingQuote.QuoteRequest_EndClient_ClientID

      };

      this.getCountryRegionCode(this.step1.selectedCountry, this.step1.selectedState,true)
      //if (quoteRequest.Region) {
      if (existingQuote.QuoteRequest_Region_ID != null) {
        Object.assign(this.step1, {
              state_id: existingQuote.QuoteRequest_Region_ID      //quoteRequest.Region.ID
          });
      }

      Object.assign(this.step2, {
          is_entity_in_country: existingQuote.QuoteRequest_DoesCompanyHaveBusinessEntityInCountry,        //quoteRequest.DoesCompanyHaveBusinessEntityInCountry,
          number_of_workers: existingQuote.QuoteRequest_NumberOfWorkers,      //quoteRequest.NumberOfWorkers,
          is_expat: !(existingQuote.QuoteRequest_IsWorkerLocal == 1),        //!quoteRequest.IsWorkerLocal,
          is_expat_visa_required: (existingQuote.QuoteRequest_IsVisaRequired == 1),      //quoteRequest.IsExpatVisaRequired,
          is_worker_in_country: (existingQuote.QuoteRequest_IsWorkerInCountry == 1)
      });

      if (existingQuote.QuoteRequest_ExpatCountry_ID != null) {
          this.step2.expat_nationality = {
              ID: existingQuote.QuoteRequest_ExpatCountry_ID,
              Name: existingQuote.QuoteRequest_ExpatCountry_Name
          };
      }

      Object.assign(this.step3, {
          is_travel_required: (existingQuote.QuoteRequest_EngagementIncludesTravel == 1),     //quoteRequest.EngagementIncludesTravel,
          job_title: this.utils.htmlDecode(existingQuote.QuoteRequest_JobTitle),      //quoteRequest.JobTitle,
          job_description: existingQuote.QuoteRequest_JobDescription,      //quoteRequest.JobDescription,
          job_description_file: existingQuote.QuoteRequest_JobDescriptionFile_Name,      //quoteRequest.JobDescriptionFile.Name,
          job_description_file_id: existingQuote.QuoteRequest_JobDescriptionFile_ID      //quoteRequest.JobDescriptionFile.ID,
          // TODO: Missing in the response
          /*type_of_work: quoteRequest.TypeOfWork,*/
      });

      if (existingQuote.QuoteRequest_JobDescriptionFile_ID != null) {
          this.JobDescriptionFile = {
              Name: existingQuote.QuoteRequest_JobDescriptionFile_Name,
              ID: existingQuote.QuoteRequest_JobDescriptionFile_ID
          };
      }

      //if (quoteRequest.JobDescriptionFile) {
      if (this.JobDescriptionFile) {
          //this.step3.jobDescriptionFileName = quoteRequest.JobDescriptionFile.Name;
          //this.step3.jobDescriptionFileID = quoteRequest.JobDescriptionFile.ID                    
          this.step3.job_description_file = this.JobDescriptionFile.Name;     //quoteRequest.JobDescriptionFile.Name;
          this.step3.job_description_file_id = this.JobDescriptionFile.ID;        //quoteRequest.JobDescriptionFile.ID                                        
      }

      Object.assign(this.step4, {
          weekly_hours: parseInt(existingQuote.QuoteRequest_TypicalWeeklyHours),       //parseInt(quoteRequest.TypicalWeeklyHours),
          pay_rate: existingQuote.QuoteRequest_PayRate,       //quoteRequest.PayRate,
          project_length_years: existingQuote.QuoteRequest_DurationYears,       //quoteRequest.DurationYears,
          project_length_months: existingQuote.QuoteRequest_DurationMonths,       //quoteRequest.DurationMonths,
          //TODO: Missing
          project_length_weeks: existingQuote.QuoteRequest_DurationWeeks,       //quoteRequest.DurationWeeks,
          is_project_length_indefinite: existingQuote.QuoteRequest_IsDurationIndefinite,       //quoteRequest.IsDurationIndefinite,
          start_date: existingQuote.QuoteRequest_StartDate === null ? '' : new Date(existingQuote.QuoteRequest_StartDate),       //new Date(quoteRequest.StartDate),
          currency_id: existingQuote.QuoteRequest_PayCurrency_ID,       //quoteRequest.PayCurrency.ID,
          pay_rate_type_id: existingQuote.QuoteRequest_PayPeriodicity_ID,       //quoteRequest.PayPeriodicity.ID,

          //Add commission handling to quote request
          is_commission_authorized: existingQuote.QuoteRequest_IsCommissionAuthorized,       //quoteRequest.IsCommissionAuthorized,
          is_bonus_authorized: existingQuote.QuoteRequest_IsBonusAuthorized,       //quoteRequest.IsBonusAuthorized,
          other_compensation: existingQuote.QuoteRequest_OtherCompensation,       //quoteRequest.OtherCompensation,

          client_notes: existingQuote.QuoteRequest_ClientNotes,       //quoteRequest.ClientNotes,
          //TODO: Missing from the response
          // payment_type_id: quoteRequest.PaymentType.ID,
          // is_expat_visa_required: 'true'
      });

      //this.step4.selectedCurrency = quoteRequest.PayCurrency;
      this.step4.selectedCurrency = {
          ID: existingQuote.QuoteRequest_PayCurrency_ID,
          Symbol: existingQuote.QuoteRequest_PayCurrency_Symbol,
          Abbreviation: existingQuote.QuoteRequest_PayCurrency_Abbreviation
      };

      //this.step4.selectedPayRateType = quoteRequest.PayPeriodicity;
      this.step4.selectedPayRateType = {
          ID: existingQuote.QuoteRequest_PayPeriodicity_ID,
          Name: existingQuote.QuoteRequest_PayPeriodicity_Name
      };
      //this.step4.selectedPayment = quoteRequest.PaymentType;

      if (this.step1.service_type_id == 2) {
          this.maxSteps = 2;
          this.allowEndClients = false;
          this.showRegions = false;
      }
      if (this.step1.service_type_id == 3) {
          this.maxSteps = 2;
          this.allowEndClients = false;
          this.showRegions = false;
      }
  }
}
populateEvaluationToQuotePopUp(existingEvaluation){
    Object.assign(this.step1, {
      include_EOR: !this.user.getEORDisabled(),
      include_Compliance: !this.user.getComplianceDisabled(),
      include_AOR: !this.user.getAORDisabled()
    });

    if(existingEvaluation){
     this.TransferEORAssingmnetId = existingEvaluation.DisplayID;

      Object.assign(this.step1, {
        service_type_id: 1,      //Default to EOR
        title: existingEvaluation.Title,
        country_id: existingEvaluation.Country.ID,
        team_id: (existingEvaluation.Team != null) ? existingEvaluation.Team.ID : 0        
      });
      this.step1.selectedCountry = existingEvaluation.Country;
      this.step1.selectedTeam = existingEvaluation.Team;

      if(existingEvaluation.Region != null){
        this.step1.selectedState = existingEvaluation.Region;
      }

      this.getCountryRegionCode(this.step1.selectedCountry, this.step1.selectedState,true)
        //if (quoteRequest.Region) {
        if (existingEvaluation.Region != null) {
          Object.assign(this.step1, {
                state_id: existingEvaluation.Region.ID      //quoteRequest.Region.ID
            });
        }

        Object.assign(this.step4, {
          start_date: existingEvaluation.StartDate
        });
  }
}
submit() {	
  // Submitted status	
  const statusId = 2;	
  return this.save(statusId).then((response) => {	
    response = response.data;
    if (response.ErrorCode == 200) {	
        this.showConfirmationToast('Thank you! We will respond to your request within 1 business day.');	
        this.router.navigate(["/quotes"], 
        {queryParams:{ service: this.step1.service_type_id }});
        this.dialogRef.close();       
        // $state.go('app.quotes', { service: $scope.step1.service_type_id });	
    } else {	
      this.dialogRef.close();
      this.showConfirmationToast('Error submitting form.');	
    }	
});	
};
showConfirmationToast(text){
  this.toast.open(text, "Got it", {
    duration: 2000,horizontalPosition:this.Hposition,
    verticalPosition:this.VPosition,
    panelClass: 'iwg-toast-text-white',
  });
}
loadCountryGuide() {
  if (this.step1.selectedCountry && this.step1.selectedState) {
    this.countryGuideService.getCountryGuidesDetail(this.step1.selectedCountry.ID, this.step1.selectedState.ID)
    .subscribe(response => {
      this.countryGuide = response.data.Data;
    });
  }
  else if (this.step1.selectedCountry) {
    this.countryGuideService.getCountryGuidesDetail(this.step1.selectedCountry.ID, 'null')
    .subscribe(response => {
      this.countryGuide = response.data.Data;
    });
  }
}
safe(){
  const text='Employer of Record: Request an employer for the worker(s). Compliance: Request evaluation of indepedent contractor engagement. Agent of Record: Request invoice and payment services for an independent contractor.';
  return this.sanitizer.sanitize(SecurityContext.HTML,text)
 }
 
 uploadedfile($ev){   
    this.step3.job_description_file=$ev;
  }

  getTabWidth(){
    if(this.selectedStepIndex < 4){
      return true;
    } else {
      return false;
    }
  }
}


